import { writable } from "svelte/store";

// /** @type {{name:string, key:string, selected:boolean}} */
export const selectedFeature = writable(null);
export const activeFeature = writable(null);
// /** @type {{name:string, key:string, colors:object, extent:array}} */
export const activeMetric = writable(null);
// /** @type {{formatted:string, value:number}} */
export const tooltip = writable({});
